import { render, staticRenderFns } from "./farmCell.vue?vue&type=template&id=52743826&scoped=true"
import script from "./farmCell.vue?vue&type=script&lang=js"
export * from "./farmCell.vue?vue&type=script&lang=js"
import style0 from "./farmCell.vue?vue&type=style&index=0&id=52743826&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52743826",
  null
  
)

export default component.exports